import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import SendBackward from '@/images/position/Backward.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { sendElementsBackward } from '../../../../actions/arrange/SendBackward';

interface Props {
    disabled: boolean;
}

export const SendBackwardMenuItem = ({ disabled }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        sendElementsBackward(store, selectedElements);
    };

    return <MenuItemIcon disabled={disabled} onClick={handleClick} src={SendBackward} text="Send backward" />;
};
